import { Outlet } from "react-router-dom";
import MainNav from "components/Navigation/MainNav";

const Default = () => {
  return (
    <>
      <MainNav />
      <div className="cc-container-m">
        <Outlet />
      </div>
    </>
  );
};

export default Default;
